var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { GRID_UNIT } from '../../utilities/grid';
export var Canvas = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: -2px;\n  height: ", "px;\n  width: ", "px;\n  line-height: ", "px;\n"], ["\n  display: inline-block;\n  vertical-align: -2px;\n  height: ", "px;\n  width: ", "px;\n  line-height: ", "px;\n"])), function (props) {
  return Number(props.size) * GRID_UNIT;
}, function (props) {
  return Number(props.size) * GRID_UNIT;
}, function (props) {
  return Number(props.size) * GRID_UNIT;
});
export var Sprite = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 100%;\n  width: auto;\n  animation: spin 0.7s linear infinite;\n  @keyframes spin {\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"], ["\n  height: 100%;\n  width: auto;\n  animation: spin 0.7s linear infinite;\n  @keyframes spin {\n    100% {\n      -webkit-transform: rotate(360deg);\n      transform: rotate(360deg);\n    }\n  }\n"])));
var templateObject_1, templateObject_2;